<template>
  <div class="calendar" v-if="client ">
    <div class="side">
      <img @click="goTo('/')" class="logo" :src="client.logo" />
      <h2>{{ calendar && calendar.title ? calendar.title : "Community Calendar" }}</h2>
      <p>
        {{
        calendar && calendar.description
        ? calendar.description
        : "We value an active and social lifestyle at Fairlane Harbor. Whether you want to learn a new skill, go dancing with a group of friends, or prefer to stay indoors and play cards, there is something for everyone! "
        }}
      </p>
    </div>

    <div class="rightside" v-if="calendar">
      <div class="events-holder">
        <div class="head">
          <p>Date/Time</p>
          <p>Event Details</p>
        </div>
        <div class="events">
          <template v-if="calendar.events && calendar.events.length">
            <div class="event" v-for="event in calendar.events" @click="chosenEvent = event">
              <div class="date-time">
                <p class="month">
                  {{ getMonthAbr(event.date) }}
                  <span class="day">{{ getDayNumber(event.date) }}</span>
                </p>
                <p class="time">{{ getTime(event.date) }}</p>
              </div>
              <div class="name">{{ event.title }}</div>
            </div>
          </template>
          <template v-else>
            <div class="gallery no-listings">
              <img src="@/assets/img/no-photo.svg" />
              <p>There are currently no new listings</p>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="rightside" v-else>
      <div class="events-holder">
        <div class="events">
          <div class="gallery no-listings">
            <img src="@/assets/img/no-photo.svg" />
            <p>There are currently no new listings</p>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="contact-popup" v-if="chosenEvent">
        <div class="close" @click="chosenEvent = null">
          <img src="@/assets/img/close.svg" />
          <p>close</p>
        </div>
        <div class="offclick" @click="chosenEvent = null"></div>
        <div class="details">
          <div class="left">
            <p class="day-month">
              {{ getDay(chosenEvent.date) }}
              <span>{{ getMonth(chosenEvent.date) }}</span>
            </p>
            <p class="day">{{ getDayNumber(chosenEvent.date) }}</p>
            <p class="time">{{ getTime(chosenEvent.date) }}</p>
          </div>
          <div class="right">
            <p class="name">{{ chosenEvent.title }}</p>
            <p class="title">
              Location:
              <span>{{ chosenEvent.location }}</span>
            </p>
            <p class="title">
              Time:
              <span>{{ getTime(chosenEvent.date) }}</span>
            </p>
            <p class="title">
              Info:
              <span>{{ chosenEvent.description }}</span>
            </p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { db, functions, analytics } from "@/config/firebaseInit";
import { Carousel, Slide } from "vue-carousel";
import Slider from "@/components/Slider";
import moment from "moment";

export default {
  name: "home",
  components: {
    Slider,
    Carousel,
    Slide
  },
  data() {
    return {
      client: this.$store.state.client,
      user: this.$store.state.user,
      calendar: this.$store.state.calendar,
      chosenEvent: null
    };
  },
  mounted() {},
  async created() {},
  watch: {},
  methods: {
    getDay(date) {
      return moment(date)
        .lang("en")
        .format("dddd");
    },
    getMonthAbr(date) {
      return moment(date)
        .lang("en")
        .format("MMM");
    },
    getMonth(date) {
      return moment(date)
        .lang("en")
        .format("MMMM");
    },
    getDayNumber(date) {
      return moment(date)
        .lang("en")
        .format("D");
    },
    getTime(date) {
      return moment(date)
        .lang("en")
        .format("LT");
    }
  }
};
</script>

<style lang="scss">
.calendar {
  height: 100vh;
  width: 100vw;
  display: flex;
  .side {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 500px;
    padding: 100px;
    flex: none;
    .logo {
      width: 275px;
      margin: auto;
      margin-top: 50px;
      margin-bottom: 30px;
    }
    h2 {
      color: black;
      font-size: 51px;
      margin-bottom: 0;
    }
    p {
      font-size: 23px;
    }
  }
  .rightside {
    background: #f7f7f7;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 50px;
    padding-right: 50px;
    .events-holder {
      padding-top: 50px;
      .head {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        p {
          font-size: 40px;
          font-weight: bold;
          width: 75%;
          margin: 0;
          text-transform: uppercase;
          &:first-child {
            width: 23.5%;
          }
        }
      }
      .events {
        overflow: hidden;
        overflow-y: auto;
        height: 963px;
        .event {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
          width: 100%;
          .date-time {
            width: 23.5%;
            background: white;
            padding: 15px 25px;
            display: flex;
            align-items: center;
            .month {
              display: flex;
              flex-direction: column;
              align-items: center;
              font-size: 25px;
              font-weight: bold;
              margin: 0;
              text-transform: uppercase;
              span {
                margin-top: -5px;
                font-size: 55px;
              }
            }
            .time {
              margin: 0;
              border-left: 3px solid black;
              padding: 10px 0;
              padding-left: 20px;
              margin-left: 20px;
              font-size: 35px;
              font-weight: bold;
            }
          }
          .name {
            width: 75%;
            background: white;
            padding: 25px 40px;
            font-size: 35px;
            font-weight: bold;
            text-transform: uppercase;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
  .contact-popup {
    .details {
      background: transparent;
      display: flex;
      justify-content: space-between;
      .left {
        background: white;
        height: 100%;
        width: 32%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .day-month,
        .time {
          font-weight: bold;
          font-size: 50px;
          text-align: center;
          text-transform: uppercase;
          span {
            display: block;
          }
        }
        .day {
          margin-top: 0;
          font-weight: bold;
          font-size: 200px;
          line-height: 1;
          margin-top: -50px;
          margin-bottom: 20px;
          text-align: center;
        }
      }
      .right {
        background: white;
        height: 100%;
        width: 66%;
        display: flex;
        flex-direction: column;
        padding: 75px 100px;
        p {
          margin: 0;
          text-align: center;
          margin-bottom: 20px;
          line-height: 1.5;
          &.name {
            font-size: 70px;
            font-weight: bold;
            margin-bottom: 50px;
          }
          &.title {
            font-size: 25px;
            font-weight: bold;
            span {
              font-weight: normal;
            }
          }
        }
      }
    }
  }
  .gallery {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    padding: 30px;
    max-height: 1080px;
    overflow: hidden;
    overflow-y: auto;
    background: #f7f7f7;
    &.no-listings {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background: #f7f7f7;
      img {
        height: 150px;
        opacity: 0.2;
      }
      p {
        margin-top: 50px;
        font-size: 40px;
        font-weight: bold;
        max-width: 400px;
        text-align: center;
      }
    }
  }
}
</style>
